module.exports = __webpack_public_path__ + "img/travel4.64f73169.png";